module.exports = __webpack_public_path__ + "static/media/financepic5@2x.02c73d59.png";